import Head from "next/head";
import {renderMetaTags} from 'react-datocms';
import {getItemUrl, getPropSafely} from "@/utils/utils";
import {LOCALES} from "@/constants";
import {useRouter} from "next/router";


function getCanonicalUrl(item, locale=LOCALES.PL){
	const url = getItemUrl(item)
	const localePrefix = locale === LOCALES.PL ? '' : `/${locale}`
	return `${process.env.SITE_URL}${localePrefix}${url}`
}
export default function Seo({ data = [], children }) {
	const metaTags = getPropSafely(data, '_seoMetaTags', [])
	const {locale} = useRouter()
	const canonical = getCanonicalUrl(data, locale)
	return (
		<Head>
			{renderMetaTags(metaTags)}
			{children}
			<link rel="canonical" href={canonical} />
			{/*<meta name="robots" content="index, follow"/>*/}
		</Head>
	)
}
